function timeAgo (updatedAt) {
  const currentDate = new Date()
  const updatedDate = new Date(updatedAt)

  const timeDifferenceInSeconds = Math.floor((currentDate - updatedDate) / 1000)

  // Define time intervals
  const minute = 60
  const hour = 60 * minute
  const day = 24 * hour
  const week = 7 * day

  // Calculate time ago
  if (timeDifferenceInSeconds < 10) {
    return 'now'
  } else if (timeDifferenceInSeconds < minute) {
    return `${timeDifferenceInSeconds} seconds ago`
  } else if (timeDifferenceInSeconds < hour) {
    const minutes = Math.floor(timeDifferenceInSeconds / minute)
    return `${minutes} minute${minutes > 1 ? 's' : ''} ago`
  } else if (timeDifferenceInSeconds < day) {
    const hours = Math.floor(timeDifferenceInSeconds / hour)
    return `${hours} hour${hours > 1 ? 's' : ''} ago`
  } else if (timeDifferenceInSeconds < week) {
    const days = Math.floor(timeDifferenceInSeconds / day)
    return `${days} day${days > 1 ? 's' : ''} ago`
  } else {
    // You can customize this part based on your needs for longer durations
    return 'more than a week ago'
  }
}

// "async" is optional;
// more info on params: https://quasar.dev/quasar-cli/boot-files
export default async ({ Vue }) => {
  Vue.prototype.$timeAgo = timeAgo
}
